import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import Grid from '@mui/material/Grid';
import './LinearProgress.scss';

const LinearProgressLoading = ({classes, className}) => {
  return (
    <Grid container>
      <Grid item sm={12} className={className}>
        <LinearProgress
          color="primary"
          aria-label="Loading"
          sx={{
            backgroundColor: '#667ca0',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#005BF8'
            },
          }}
        />
      </Grid>
    </Grid>
  );
};

export default LinearProgressLoading;